import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { DatesService } from "src/app/shared/services/dates.service";

@Component({
  selector: 'app-modal-seleccion-documento',
  templateUrl: './modal-seleccion-documento.component.html',
  styleUrls: ['./modal-seleccion-documento.component.scss'],
  providers: [SecurityService],
})
export class ModalSeleccionDocumentoComponent implements OnInit {

  // Input
  @Input() tipo_dte_codigo: number = 0
  @Input() es_nc: boolean = false
  @Input() es_nd: boolean = false
  @Input() tipo_ncnd: number = 0

  // Output
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotFound: EventEmitter<any> = new EventEmitter<any>();

  // Modales
  @ViewChild('seleccionarFactura', { static: true }) seleccionarFacturaModal: ModalDirective;

  // Form
  formData: FormGroup

  // Data
  private rutEmpresa: Number
  private sucursalEmpresa: Number
  data: any = []
  paginationContext: PaginationContext = new PaginationContext()
  busquedaIniciada: boolean = false
  loading: boolean = false

  // Utils
  private log: any
  proveedorRut: number;
  resultData: any;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private datesService: DatesService,
  ) {
    this.log = this.clog.log('MODAL-SELECCION-FACTURA')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.paginationContext.RecordsByPage = 10

    this.createForm()
  }

  createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formData = this.fb.group({
      folio: [null],
      rut: [null],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      nombre: [null]
    });
  }

  show(cleanData: Boolean = true) {
    if (cleanData) {
      this.cleanAll()
    }
    this.seleccionarFacturaModal.show();
  }

  load(rutProveedor: number){
    this.proveedorRut =  this.rutService.QuitarDV(this.rutService.Limpiar(rutProveedor));

    this.seleccionarFacturaModal.show();
    this.cleanAll()
  }

  hide() {
    this.seleccionarFacturaModal.hide();
  }

  private cleanAll() {
    this.cleanFormData()
    this.cleanResultData()
  }

  private cleanFormData() {
    this.formData.reset()
    this.formData.markAsPristine()
    this.formData.markAsUntouched()

    this.initializeFormData()
  }

  private cleanResultData() {
    this.busquedaIniciada = false
    this.data = []
    this.loading = false
  }

  private initializeFormData() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formData.get("folio").setValue(null)
    this.formData.get("rut").setValue(null)
    this.formData.get("fechaDesde").setValue(initDate)
    this.formData.get("fechaHasta").setValue(currentDate)
    this.formData.get("nombre").setValue(null)
  }

  /********* OPERATIONS *********/
  buscarTodos(fromStartPage: Boolean = false) {
    if (fromStartPage) this.paginationContext.CurrentPage = 1

    // limpiar datos antes de desplegar
    this.cleanResultData()
    const inputParams = this.createInputParamsBuscarTodos()
    this.loading = true
    this.executeQueryBuscarTodos(inputParams, (result) => this.renderQueryResults(result))
  }


  // rut
  // fechaDesde
  // fechaHasta
  // nombre

  private createInputParamsBuscarTodos() {
    const { folio, rut, nombre } = this.formData.value
    let rutSinDv = 0;
    if (rut)
      rutSinDv = this.rutService.QuitarDV(this.rutService.Limpiar(rut))

    let payload : any =
    {
      entidad: {
        rut_emisor: this.proveedorRut,
        sucursal_codigo: this.sucursalEmpresa,
        rut_empresa:  this.rutEmpresa,
        tipo_dte_codigo: 33,
        folio: this.formData.get('folio').value,
        cliente_proveedor_nombre: this.formData.get('nombre').value != null ? this.formData.get('nombre').value : "" ,
        // rut_cliente_proveedor: this.formData.get('rut').value,
        fecha_desde: this.formData.get('fechaDesde').value,
        fecha_hasta: this.formData.get('fechaHasta').value,
        tipo_ncnd_codigo: this.tipo_ncnd
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1
    }

   return payload
  }

  private renderQueryResults(result: QueryResult) {
    const { registros, paginaActual, totalPaginas, totalRegistros } = result
    this.log('registros', registros, result)
    this.loading = false
    this.paginationContext.RecordsCount = totalRegistros
    this.paginationContext.CurrentPage = paginaActual
    this.paginationContext.PagesCount = totalPaginas
    this.data = registros
    this.data.forEach(element => {
      // delete element.__typename
      this.cleanIncomingData(element)
    });
    this.busquedaIniciada = true
  }

  private cleanIncomingData(register: any) {
    delete register.__typename
  }

  private executeQueryBuscarTodos(inputParams: any, callback: Function) {
    const self = this
    this.log('inputParams', JSON.stringify(inputParams))
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: documento_recibidoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          documento_recibido {
            obtenerFacturaRecibidas(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_empresa
                  sucursal_codigo
                  folio
                  tipo_dte_codigo
                  rut_emisor
                  cliente_proveedor_nombre
                  bodega_codigo
                  id_doc
                  id_xml
                  mov_inv_ejecutado
                  mov_cta_cte
                  fecha_registro
                  monto_total
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (_respuesta) {
        const { mensajes, respuesta } = _respuesta.data.documento_recibido.obtenerFacturaRecibidas
        const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
        if (!ok) {
          self.messageRendererService.showErrors(mensajes)
          callback(new QueryResult(null, 0, 0, 0))
          return
        }

        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta

        // callback({ registros, paginaActual, totalPaginas, totalRegistros })
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros))
      }
    );
  }

  public executeQueryBuscarDocumentoByFolio({ folio, tipo_dte_codigo }, callback: Function) {
    const inputParams = {
      entidad:{
        cabecera:{
          rut_empresa: this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          rut_emisor: this.proveedorRut,
          folio,
          tipo_dte_codigo: tipo_dte_codigo, // TODO: Dummy data
          es_nc_pacial: this.es_nd, //TODO: **tipo_doc_parcial** puede ser false,por anulacion o true para ser Parcial
        }
      }
    }

    this.log('inputParams', JSON.stringify(inputParams))
    const self = this
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: documento_recibidoDTOInputType) {
          documento_recibido {
            obtenerFacturaRecibidaEspecifica(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                cabecera {
                  rut_emisor
                  folio
                  tipo_dte_codigo
                  rut_empresa
                  sucursal_codigo
                  id_doc
                  id_xml
                  fecha_vencimiento
                  monto_total
                  monto_neto
                  monto_exento
                  monto_descuento
                  monto_recargo
                  monto_subtotal
                  monto_imp_adic
                  monto_iva
                  iva_recuperable
                  iva_no_recuperable
                  iva_activo_fijo
                  iva_retenido
                  iva_comun
                }
                detalleDocumento {
                  rut_emisor
                  tipo_dte_codigo
                  folio
                  nro_linea
                  gasto_codigo
                  equivalencia_producto_id
                  codigo_producto_proveedor
                  descripcion_producto_proveedor
                  detalle_adicional
                  cantidad
                  precio_producto_proveedor
                  monto_total
                  es_porcentaje_dscto
                  monto_descuento
                  es_porcentaje_recargo
                  monto_recargo
                  producto_valido
                  producto_codigo
                  formato_codigo
                  formato_proveedor
                  precio_neto
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (_respuesta) {
        const { mensajes, respuesta } = _respuesta.data.documento_recibido.obtenerFacturaRecibidaEspecifica
        const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
        if (!ok) {
          self.messageRendererService.showErrors(mensajes)
          callback(null)
          return
        }

        delete respuesta.__typename

        // const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
        // callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros))
        callback(respuesta)
      }
    );
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage
    this.buscarTodos()
  }

  // Se consume desde la vista
  selectData(documento) {
    this.executeQueryBuscarDocumentoByFolio(documento, (result: any) => {
      if (result) {
        this.emitirSeleccionado(result)
        this.hide()
      }
    }
    )
  }

  private emitirSeleccionado(data) {
    this.lastFolio = data.cabecera.folio
    this.lastFechaEmision = data.cabecera.fecha_emision
    this.onSelect.emit({
      data
    })
  }

  private emitirNotFound() {
    this.resultData = null
    this.onNotFound.emit(this.resultData)
  }

  // Método para ser consumido desde fuera del componente
  lastFolio: any = null
  lastFechaEmision: any = null
  searchByNroDoc(folio: any, tipo_dte_codigo: any, proveedor: number) {
    this.proveedorRut = this.rutService.QuitarDV(this.rutService.Limpiar(proveedor));
    if (folio === this.lastFolio)
      return
    this.executeQueryBuscarDocumentoByFolio({
      folio,
      tipo_dte_codigo
    }, (result: any) => {
      this.log('searchByNroDoc', result)
      if (result != null){
        this.emitirSeleccionado(result)
        return result
      }else{
        this.emitirNotFound()
      }

      this.hide()
    }
    )
  }

  clearLast() {
    this.lastFolio = null
  }
  /********* OPERATIONS *********/

}
